import React from 'react'
import Head from '@fs/zion-head'

export default function BrightspotIdMetaTag({ id }) {
  return (
    <Head>
      <meta name="brightspot.id" content={id} />
    </Head>
  )
}
